// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.base.dark};
  min-height: 640px;
`;

export const Background = styled.div`
  width: 858px;
  &::after {
    content: '';
    position: absolute;
    width: 1440px;
    height: 688px;
    background: radial-gradient(
      73.98% 72.57% at 0% -5.88%,
      rgba(11, 212, 193, 0.5) 0%,
      rgba(7, 14, 39, 0) 90.33%
    );
  }
  &::before {
    content: '';
    position: absolute;
    right: 0;
    width: 1440px;
    height: 688px;
    background: radial-gradient(
      71.66% 72.21% at 89.06% 11.06%,
      rgba(242, 22, 115, 0.25) 0%,
      rgba(7, 14, 39, 0) 100%
    );
  }
`;

export const LeftContainer = styled.div`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    max-width: 600px;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 522px;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    & h2 {
      max-width: 460px;
    }
    & div div span {
      white-space: nowrap;
    }
  }
`;

export const HeroLoader = styled.div`
  ${({ theme }) => theme.breakpoints.down('sm')} {
    height: 480px;
  }
  aspect-ratio: 16/10;
  background-color: ${({ theme }) => theme.colors.base.dark};
`;
